window.$ = window.jQuery = require('jquery');
require('bootstrap');

require('default-passive-events');

import Vue from 'vue';

Vue.component('search-job', () => import('./components/SearchJob.js'));
Vue.component('select-job-home', () => import('./components/SelectJobHome.js'));
Vue.component('v-dometer', () => import('./components/libs/Dometer.vue'));
Vue.component('v-search-job', () => import('./components/SearchJobComponent.js'));
Vue.component('load-dom', require('./components/LoadDom.js').default);

const app = new Vue({
  el: '#app',
});
